import React, { useCallback, memo, useEffect } from 'react';
import { FormTimesheetLabel } from 'modules/timesheet-labels/labelSchema';
import { FetchSuggestionsHandlerProps } from 'modules/notes/addNote/hooks';
import { TimesheetLabels } from 'modules/timesheet-labels';
import { useFormErrorDialogContext } from 'modules/notes/common';
import { useSplitEntryFetchSuggestions } from '../../hooks';

type TimesheetLabelsSplitContentProps = {
  loading: boolean;
  fields: FormTimesheetLabel[];
  position: number;
  setIsFormError: React.Dispatch<React.SetStateAction<boolean>>;
};

const TimesheetLabelsSplitContent: React.FC<TimesheetLabelsSplitContentProps> = ({
  loading,
  fields,
  position,
  setIsFormError
}: TimesheetLabelsSplitContentProps) => {
  const { fetchSuggestions } = useSplitEntryFetchSuggestions(position);
  const { errorContext } = useFormErrorDialogContext();

  useEffect(() => {
    setIsFormError(errorContext.commentExceeded);
  }, [errorContext.commentExceeded, setIsFormError]);

  const onLabelChange = useCallback(
    (props: FetchSuggestionsHandlerProps) => {
      fetchSuggestions(position)(props);
    },
    [fetchSuggestions, position]
  );
  return (
    <TimesheetLabels
      fields={fields}
      loading={loading}
      onLabelChange={onLabelChange}
    />
  );
};
export default memo(TimesheetLabelsSplitContent);
